import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Clock, Instagram } from 'lucide-react';
import { Button, WHATSAPP_URL } from './ui/Button';
export function Contact() {
  return <section id="contacto" className="py-24 bg-nude relative" data-id="element-11">
      <div className="container mx-auto px-6 md:px-12" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-14">
            <h2 className="text-4xl md:text-5xl font-serif text-deepblack mb-6" data-id="element-15">
              Visitanos en{' '}
              <span className="italic font-light text-rosegold" data-id="element-16">AURA</span>
            </h2>
            <p className="text-lg text-deepblack/70 font-sans font-light mb-12 max-w-md" data-id="element-17">
              Un espacio diseñado exclusivamente para tu confort y relajación.
              Te esperamos para brindarte la mejor atención.
            </p>

            <div className="space-y-8" data-id="element-18">
              <div className="flex items-start gap-4" data-id="element-19">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-rosegold shrink-0 shadow-sm" data-id="element-20">
                  <MapPin className="w-5 h-5" data-id="element-21" />
                </div>
                <div data-id="element-22">
                  <h4 className="font-serif font-semibold text-deepblack text-lg" data-id="element-23">
                    Ubicación
                  </h4>
                  <p className="text-deepblack/70 font-sans mt-1" data-id="element-24">
                    Av. Argentina 123, Neuquén
                    <br data-id="element-25" />
                    Patagonia, Argentina
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-26">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-rosegold shrink-0 shadow-sm" data-id="element-27">
                  <Phone className="w-5 h-5" data-id="element-28" />
                </div>
                <div data-id="element-29">
                  <h4 className="font-serif font-semibold text-deepblack text-lg" data-id="element-30">
                    Contacto
                  </h4>
                  <p className="text-deepblack/70 font-sans mt-1" data-id="element-31">
                    +54 9 299 519-2151
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-32">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-rosegold shrink-0 shadow-sm" data-id="element-33">
                  <Clock className="w-5 h-5" data-id="element-34" />
                </div>
                <div data-id="element-35">
                  <h4 className="font-serif font-semibold text-deepblack text-lg" data-id="element-36">
                    Horarios
                  </h4>
                  <p className="text-deepblack/70 font-sans mt-1" data-id="element-37">
                    Lunes a Sábados
                    <br data-id="element-38" />
                    09:00 hs a 20:00 hs
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-39">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-rosegold shrink-0 shadow-sm" data-id="element-40">
                  <Instagram className="w-5 h-5" data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <h4 className="font-serif font-semibold text-deepblack text-lg" data-id="element-43">
                    Instagram
                  </h4>
                  <a href="#" className="text-rosegold font-sans mt-1 hover:underline" data-id="element-44">
                    @aura.estetica
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form / Map Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-nude-dark relative overflow-hidden" data-id="element-45">
            <div className="absolute top-0 right-0 w-32 h-32 bg-rosegold/5 rounded-bl-full -z-10" data-id="element-46"></div>

            <h3 className="text-2xl font-serif text-deepblack mb-8" data-id="element-47">
              Envianos tu consulta
            </h3>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-48">
              <div data-id="element-49">
                <label className="block text-sm font-sans text-deepblack/70 mb-2" data-id="element-50">
                  Nombre completo
                </label>
                <input type="text" className="w-full bg-nude/50 border border-nude-dark rounded-lg px-4 py-3 focus:outline-none focus:border-rosegold focus:ring-1 focus:ring-rosegold transition-colors font-sans" placeholder="Tu nombre" data-id="element-51" />
              </div>

              <div data-id="element-52">
                <label className="block text-sm font-sans text-deepblack/70 mb-2" data-id="element-53">
                  Teléfono
                </label>
                <input type="tel" className="w-full bg-nude/50 border border-nude-dark rounded-lg px-4 py-3 focus:outline-none focus:border-rosegold focus:ring-1 focus:ring-rosegold transition-colors font-sans" placeholder="Tu número" data-id="element-54" />
              </div>

              <div data-id="element-55">
                <label className="block text-sm font-sans text-deepblack/70 mb-2" data-id="element-56">
                  Servicio de interés
                </label>
                <select className="w-full bg-nude/50 border border-nude-dark rounded-lg px-4 py-3 focus:outline-none focus:border-rosegold focus:ring-1 focus:ring-rosegold transition-colors font-sans appearance-none" data-id="element-57">
                  <option value="" data-id="element-58">Seleccioná un tratamiento</option>
                  <option value="facial" data-id="element-59">Tratamiento Facial</option>
                  <option value="corporal" data-id="element-60">Tratamiento Corporal</option>
                  <option value="depilacion" data-id="element-61">Depilación Definitiva</option>
                  <option value="otro" data-id="element-62">Otro / Consulta general</option>
                </select>
              </div>

              <Button href={WHATSAPP_URL} className="w-full" data-id="element-63">
                Contactar por WhatsApp
              </Button>
              <p className="text-xs text-center text-mauve font-sans mt-4" data-id="element-64">
                Te redirigiremos a WhatsApp para una atención más rápida y
                personalizada.
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}